
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h2>{`Testing Strategy`}</h2>
<h3>{`E2E Testing`}</h3>
<p>{`Several end-to-end scenarios are run (searching, configuring charts) for every pull-request.`}</p>
<h3>{`Snapshot Regression Testing`}</h3>
<ul>
<li parentName="ul">{`Existing chart configurations are downloaded from the `}<del parentName="li">{`production`}</del>{` develompent environment stored in `}<inlineCode parentName="li">{`app/test/__fixtures`}</inlineCode></li>
<li parentName="ul">{`Running `}<inlineCode parentName="li">{`yarn test`}</inlineCode>{` will compare `}<strong parentName="li">{`image snapshots`}</strong>{` of the rendered charts with previous snapshots. When the new snapshots differ more than a certain threshold, the test will fail and a diff will be stored to inspect.`}</li>
</ul>
<p>{`To prevent regressions between releases, snapshot `}<strong parentName="p">{`tests are run automatically before a new version is applied`}</strong>{`.`}</p>
<h3>{`Notes`}</h3>
<ul>
<li parentName="ul">{`The snapshot tests rely on the app server running on http://localhost:3000`}</li>
<li parentName="ul">{`Fixtures can be updated by running `}<inlineCode parentName="li">{`./scripts/fetch-config-fixtures.js`}</inlineCode>{`. Make sure that tests are passing before running this command and delete the `}<inlineCode parentName="li">{`__image_snapshots__`}</inlineCode>{` directory in `}<inlineCode parentName="li">{`app/test/`}</inlineCode>{` to get a fresh set of snapshots.`}</li>
</ul>
<h3>{`To Do`}</h3>
<ul>
<li parentName="ul">{`Download full data for test fixtures incl. observations, so tests can run faster and don't rely on network requests.`}</li>
</ul>
<h2>{`Query performance`}</h2>
<p>{`A developer tool to monitor resolver performance and SPARQL queries that are made by the server
is available if a page is accessed with the `}<inlineCode parentName="p">{`flag__debug=true`}</inlineCode>{` query parameter.`}</p>
<p>{`See for example `}<a parentName="p" {...{
        "href": "https://test.visualize.admin.ch/en?flag__debug=true"
      }}>{`https://test.visualize.admin.ch/en?flag__debug=true`}</a></p>
<p>{`A small 🛠 should be present in the lower corner of the screen and clicking it will display the
GraphQL debug panel. This panel shows every GraphQL query that is made to the server and queries
can be inspected to see the timings of its resolvers. SPARQL queries made during requests are
also collected and shown.`}</p>
<p>{`⚠️ To be able to collect SPARQL queries, we need to monkey-patch the SPARQL client. If a library
uses its own SPARQL client, we cannot monitor the SPARQL queries made, so some requests that
are made can be missing.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;